import { render, staticRenderFns } from "./DistribuirConceito.vue?vue&type=template&id=580a4176&"
import script from "./DistribuirConceito.vue?vue&type=script&lang=js&"
export * from "./DistribuirConceito.vue?vue&type=script&lang=js&"
import style0 from "./DistribuirConceito.vue?vue&type=style&index=0&id=580a4176&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports